import React from "react";
import PropTypes from "prop-types";
import { IoPerson, IoBusiness } from "react-icons/io5";

import CustomerSelect from "../common/CustomerSelect";
import DepartmentSelect from "../common/DepartmentSelect";
import CallTypeSelect from "../common/CallTypeSelect";
import ProjectSelect from "../common/ProjectSelect";
import UserSelect from "../common/UserSelect";
import CustomToggle from "../common/Toggle";
import InvoiceFrequencySelect from "../common/InvoiceFrequencySelect";

const CallApprovalFilters = ({
  children,
  onChange,
  filters,
  loading,
  setCustomers,
  setProjects,
  setLoading,
  displayGroupByCustomer,
  displayInvoiceFrequencyFilter
}) => (
  <div className="report-filters">
    <CustomerSelect
      isMulti
      isLoading={loading}
      disabled={loading}
      setGlobalLoading={setLoading}
      onChange={onChange("customer")}
      loadCustomers={setCustomers}
      value={filters.customer || []}
    />
    <ProjectSelect
      isLoading={loading}
      disabled={loading}
      setGlobalLoading={setLoading}
      selectedCustomers={filters.customer}
      onChange={onChange("project")}
      loadProjects={setProjects}
      value={filters.project || []}
      filterResult={(project) =>
        project.project_status.label === "In Process" ||
        project.project_status.label === "Ready To Close"
      }
    />
    <UserSelect
      disabled={loading}
      isMulti
      value={filters.project_manager}
      placeholder="Project Manager"
      onChange={onChange("project_manager")}
    />
    <DepartmentSelect
      isMulti
      disabled={loading}
      isLoading={loading}
      onChange={onChange("department")}
      value={filters.department}
    />
    <CallTypeSelect
      isMulti
      disabled={loading}
      isLoading={loading}
      onChange={onChange("call_type")}
      value={filters.call_type}
      placeholder="Call Type"
    />
    <UserSelect
      selectedDepartment={filters.department}
      disabled={loading}
      isMulti
      value={filters.multi_assigned_to}
      onChange={onChange("multi_assigned_to")}
    />
    {displayInvoiceFrequencyFilter ? (
      <InvoiceFrequencySelect
        disabled={loading}
        isLoading={loading}
        values={filters.invoice_frequency || []}
        onChange={onChange("invoice_frequency")}
      />
    ) : null}
    <input
      type="date"
      disabled={loading}
      placeholder="Start Date"
      value={filters.start_date}
      onChange={(e) => onChange("start_date")(e.target.value)}
    />
    <input
      type="date"
      disabled={loading}
      placeholder="End Date"
      value={filters.end_date}
      onChange={(e) => onChange("end_date")(e.target.value)}
    />
    <CustomToggle
      columnSize={6}
      name="only_flagged"
      label="Show Only Flagged"
      onChange={(e) => onChange("only_flagged")(e.target.checked)}
      value={filters.only_flagged}
    />
    {displayGroupByCustomer && (
      <CustomToggle
        columnSize={6}
        name="grouped_by_customer"
        label="Group By Customer"
        onChange={(e) => onChange("grouped_by_customer")(e.target.checked)}
        value={filters.grouped_by_customer}
        checkedIcon={<IoPerson />}
        uncheckedIcon={<IoBusiness />}
      />
    )}
    {children}
  </div>
);
CallApprovalFilters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  children: PropTypes.node,
  loading: PropTypes.bool,
  setCustomers: PropTypes.func,
  setProjects: PropTypes.func,
  setLoading: PropTypes.func,
  displayGroupByCustomer: PropTypes.bool,
  displayInvoiceFrequencyFilter: PropTypes.bool
};
export default CallApprovalFilters;
